import React, { Component } from 'react';
import { SpinnerCircular } from 'spinners-react';
import '../assets/css/Spinner.css';

export class Spinner extends Component {
  render() {
    return (
      <div className='spinnerbackground'>
        <SpinnerCircular />
      </div>
    )
  }
}

export default Spinner
